export function getAffiliateDataFromRegistrationLink() {
  const urlParams = new URLSearchParams(window.location.search);

  return {
    affiliateId: urlParams.get("affiliateId") ?? urlParams.get("affiliateid"),
    affiliateAccepted: urlParams.get("affiliatePartnerConfirmed") === "true",
    affiliatePartnerConfirmedSpecified: urlParams.has("affiliatePartnerConfirmed"),
    selectedSubsidiary: urlParams.get("selectedSubsidiary"),
  };
}

export interface RegistrationAffiliateContext {
  affiliateId?: string;
  salesPartnerId?: string;
  affiliatePartnerConfirmed: boolean;
}

/**
 * Combines the existing registration-link adapter with the typed affiliate state
 * already owned by the application store. Callers pass the result to the
 * registration request explicitly; the request adapter does not read runtime
 * state itself.
 */
export function toRegistrationAffiliateContext({
  registrationLink,
  savedAffiliate,
  savedSubsidiaryId,
}: {
  registrationLink: ReturnType<typeof getAffiliateDataFromRegistrationLink>;
  savedAffiliate?: { affiliateId?: string | null } | null;
  savedSubsidiaryId?: string | null;
}): RegistrationAffiliateContext {
  return {
    affiliateId: registrationLink.affiliateId ?? savedAffiliate?.affiliateId ?? undefined,
    salesPartnerId: registrationLink.selectedSubsidiary ?? savedSubsidiaryId ?? undefined,
    affiliatePartnerConfirmed: registrationLink.affiliatePartnerConfirmedSpecified
      ? registrationLink.affiliateAccepted
      : !!savedAffiliate?.affiliateId,
  };
}
